/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../onboarding/recommendations/common';
import '../../../../onboarding/resume/common';
import '../../common/locale';
import '../../resources/product';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "SoftwareProducts": {
                    "fields": {
                      "paymentSoftware": {
                        "type": "squareup.onboarding.recommendations.common.Product",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "addonSoftware": {
                        "type": "squareup.onboarding.recommendations.common.Addon",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  },
                  "ListMpoRecommendedProductsRequest": {
                    "fields": {
                      "merchantToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentLocations": {
                        "type": "squareup.onboarding.resume.common.MpoPaymentLocations",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "softwareProducts": {
                        "type": "squareup.solidshop.v2.service.SoftwareProducts",
                        "id": 3,
                        "rule": "optional"
                      },
                      "storeCode": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "locale": {
                        "type": "squareup.solidshop.v2.common.Locale",
                        "id": 5,
                        "rule": "optional",
                        "options": {
                          "default": "EN_US"
                        }
                      }
                    }
                  },
                  "ListMpoRecommendedProductsResponse": {
                    "fields": {
                      "products": {
                        "type": "squareup.solidshop.v2.resources.Product",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 2,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE SoftwareProducts @ squareup/solidshop/v2/service/products/list_mpo_recommended_products.proto at 14:1
 */
export const SoftwareProducts = $root.lookupType('squareup.solidshop.v2.service.SoftwareProducts');
fixType(SoftwareProducts);
Builder.createAndAttachToType(SoftwareProducts);
/**
 * SOURCE ListMpoRecommendedProductsRequest @ squareup/solidshop/v2/service/products/list_mpo_recommended_products.proto at 22:1
 */
export const ListMpoRecommendedProductsRequest = $root.lookupType('squareup.solidshop.v2.service.ListMpoRecommendedProductsRequest');
fixType(ListMpoRecommendedProductsRequest);
Builder.createAndAttachToType(ListMpoRecommendedProductsRequest);
/**
 * SOURCE ListMpoRecommendedProductsResponse @ squareup/solidshop/v2/service/products/list_mpo_recommended_products.proto at 39:1
 */
export const ListMpoRecommendedProductsResponse = $root.lookupType('squareup.solidshop.v2.service.ListMpoRecommendedProductsResponse');
fixType(ListMpoRecommendedProductsResponse);
Builder.createAndAttachToType(ListMpoRecommendedProductsResponse);
